/**
 * Whether URL query params drive the client on the current host.
 *
 * The second screen honors `?…` params only on its own surfaces (the hosted
 * embed and local dev). On a JS embed running inside a customer's page we read
 * `data-*` attributes instead, and must never read or mutate the customer's URL.
 */
export function urlParamsEnabled(): boolean {
  return (
    window.location.hostname === "p3.3playmedia.com" ||
    window.location.hostname === "localhost"
  );
}
